import qs from "qs";
import axios from "axios";
import { URL, API_URL } from "../../../constants/Constants";

/**
 * Obtiene todos los documentos de todos los clientes
 * @param {string} type - Tipo de pantalla (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {number} currentScreenId - ID de la pantalla actual (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Array|false>} Datos de documentos o false si no se encuentran
 */
export const getFullDocumentAllClient = async (type, typeConnect, currentScreenId) => {
  const queryData = {
    screen: "document",
    action: "query",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
